<template>
  <div class="container box" id="container-main">
    <div class="row" id="main-row">
      <div id="vapp">
        <div class="header">
          <h1 class="title">Customers</h1>
          <div v-if="HasGroup(['Developer', 'Support', 'Finance'])" class="buttonsGroup">
            <b-tooltip v-if="HasGroup(['Developer', 'Support'])" label="Add a Customer" position="is-top"
              ><button class="button is-medium is-success" @click="isNewItemActive = true">
                <b-icon icon="plus" size="is-small"></b-icon>
              </button>
            </b-tooltip>
            <b-tooltip label="Edit Customer" position="is-top">
              <button class="button is-medium is-success" @click="isEditItemActive = true">
                <b-icon icon="pencil" size="is-small"></b-icon>
              </button>
            </b-tooltip>
            <b-tooltip v-if="HasGroup(['Developer', 'Support'])" label="Delete a Customer" position="is-top"
              ><button class="button is-medium is-danger" @click="DeleteItem()">
                <b-icon icon="trash" size="is-small"></b-icon>
              </button>
            </b-tooltip>
          </div>
        </div>
        <template>
          <b-table :data="this.customers" :selected.sync="selected" :loading="this.isLoading" default-sort="id" default-sort-direction="asc" hoverable sticky-header>
            <b-table-column field="disctools_id" v-if="HasGroup(['Developer', 'Support'])" label="Customer ID" sortable v-slot="props">
              {{ props.row.disctools_id }}
            </b-table-column>
            <b-table-column field="uuid" label="UUID" sortable v-slot="props" searchable>
              {{ props.row.uuid }}
            </b-table-column>
            <b-table-column field="customer_name" label="Customer Name" sortable v-slot="props" searchable>
              {{ props.row.customer_name }}
            </b-table-column>
            <b-table-column v-if="HasGroup(['Developer', 'Support', 'Finance'])" field="cost" label="Price per call" v-slot="props">
              {{ FormatAmount(props.row.call_cost.toFixed(2), props.row.currency) }}
            </b-table-column>
            <b-table-column v-if="HasGroup(['Developer', 'Support', 'Finance'])" field="fixedLocCost" label="F/L Price per call" v-slot="props">{{
              FormatAmount(props.row.fixed_loc_cost.toFixed(2), props.row.currency)
            }}</b-table-column>
            <b-table-column v-if="HasGroup(['Developer', 'Support', 'Finance'])" field="currency" label="Currency" v-slot="props">
              {{ props.row.currency }}
            </b-table-column>
            <b-table-column v-if="HasGroup(['Developer', 'Support'])" field="region" label="Region" v-slot="props">
              {{ GetRegionIDsName(props.row.region_id) }}
            </b-table-column>
            <b-table-column label="Added" v-slot="props">
              {{ FormatDate(props.row.added) }}
            </b-table-column>
            <b-table-column v-slot="props">
              <b-button type="is-info is-light" @click="$router.push('/voiceplus/dashboard/' + props.row.disctools_id)">View Stats</b-button>
            </b-table-column>
          </b-table>
        </template>
        <b-modal :active.sync="isNewItemActive" has-modal-card trap-focus :destroy-on-hide="false" aria-role="dialog" aria-modal>
          <new-module @submitted="AddCustomer" :regions="this.regions" :item="this.formProps"></new-module>
        </b-modal>
        <b-modal :active.sync="isEditItemActive" has-modal-card trap-focus :destroy-on-hide="false" aria-role="dialog" aria-modal>
          <edit-module @submitted="UpdateCustomer" :item="this.selected" :currencies="this.currencies"></edit-module>
        </b-modal>
      </div>
    </div>
    <b-loading :is-full-page="true" v-model="bigLoading" :can-cancel="true"></b-loading>
  </div>
</template>

<script>
const axios = require("axios");
const moment = require("moment");

const EditModule = {
  props: {
    item: {
      type: Object,
      required: true,
    },
    currencies: {
      type: Object,
      required: true,
    },
  },
  data: function () {
    return {
      timezones: [],
      debug_mode: ["none", "full", "partial"],
    };
  },
  methods: {},
  mounted() {
    this.timezones = moment.tz.names();
  },
  template: `
        <form @submit.prevent="">
            <div class="modal-card">
                <header class="modal-card-head">
                    <p class="modal-card-title">Edit Customer</p>
                </header>
                <section class="modal-card-body">
                <b-field label="Customer Name">
                  <b-input type="text" placeholder="" v-model="item.customer_name" disabled></b-input>
                </b-field>
                <b-field label="UID">
                  <b-input type="text" placeholder="" v-model="item.uuid"></b-input>
                </b-field>
                <b-field label="Price per Call">
                  <b-input type="text" placeholder="" v-model="item.call_cost"></b-input>
                </b-field>
                <b-field label="F/L Price per Call">
                  <b-input type="text" placeholder="" v-model="item.fixed_loc_cost"></b-input>
                </b-field>
                <b-field label="Currency">
                  <b-select v-model="item.currency">
                    <option v-for="(key, currency) of currencies">
                      {{currency}}
                    </option>
                  </b-select>
                </b-field>
                <b-field label="Timezone">
                  <b-select v-model="item.timezone">
                    <option v-for="timezone in timezones">
                      {{timezone}}
                    </option>
                  </b-select>
                </b-field>
                <b-field label="Debug Mode">
                  <b-select v-model="item.log_level">
                    <option v-for="mode in debug_mode" :value="mode">
                      {{ mode.charAt(0).toUpperCase() +  mode.slice(1) }}
                    </option>
                  </b-select>
                </b-field>
                </section>
                <footer class="modal-card-foot">
                    <button class="button" type="button" @click="$parent.close()">Cancel</button>
                    <button class="button is-primary" @click="$emit('submitted')">Update</button>
                </footer>
            </div>
        </form>
        `,
};
const NewModule = {
  props: {
    item: {
      type: Object,
      required: true,
    },
    regions: {
      type: Array,
      required: true,
    },
  },
  data: function () {
    return {
      data: [],
      isFetching: false,
      selected: null,
      discToolsUrl: "https://disctools.co.uk",
      regions: [],
      awsRegions: {
        "us-east-1": "US East (N. Virginia)",
        "us-east-2": "US East (Ohio)",
        "us-west-1": "US West (N. California)",
        "us-west-2": "US West (Oregon)",
        "ca-central-1": "Canada (Central)",
        "eu-west-1": "EU (Ireland)",
        "eu-central-1": "EU (Frankfurt)",
        "eu-west-2": "EU (London)",
        "eu-west-3": "EU (Paris)",
        "eu-north-1": "EU (Stockholm)",
        "ap-northeast-1": "Asia Pacific (Tokyo)",
        "ap-northeast-2": "Asia Pacific (Seoul)",
        "ap-southeast-1": "Asia Pacific (Singapore)",
        "ap-southeast-2": "Asia Pacific (Sydney)",
        "ap-south-1": "Asia Pacific (Mumbai)",
        "sa-east-1": "South America (São Paulo)",
        "us-gov-west-1": "US Gov West 1",
        "us-gov-east-1": "US Gov East 1",
      },
    };
  },
  methods: {
    getAsyncData: async function (name) {
      if (!name.length) {
        this.data = [];
        return;
      }
      this.isFetching = true;
      const token = await this.$cognitoAuth.getIdToken();
      const config = {
        headers: { Authorization: "Bearer " + token },
      };
      axios
        .get(this.discToolsUrl + "/api/customers?q=" + name, config)
        .then(({ data }) => {
          this.data = data.data;
        })
        .catch((error) => {
          this.data = [];
          throw error;
        })
        .finally(() => {
          this.isFetching = false;
        });
    },
  },
  mounted() {
    this.GetRegionsModal();
  },
  template: `
        <form @submit.prevent="">
            <div class="modal-card">
                <header class="modal-card-head">
                    <p class="modal-card-title">Add Customer</p>
                </header>
                <section class="modal-card-body">
                    <b-field label="Customer Name">
                        <b-autocomplete
                            id="customerAutocomplete"
                            v-model="item.selected"
                            :data="data"
                            placeholder="e.g. joeg"
                            :loading="isFetching"
                            @typing="getAsyncData"
                            :append-to-body="true"
                            field="CustomerName"
                            @select="option => item.customer = option"
                            required>
                            <template slot="empty">No results found</template>
                        </b-autocomplete>
                    </b-field>
                    <b-field label="Region">
                      <b-select placeholder="Select a region" v-model="item.region_id">
                          <option
                              v-for="region in regions"
                              :value="region.id"
                              :key="region.id">
                              {{ region.region_name }} - {{ awsRegions[region.region_name] }}
                          </option>
                      </b-select>
                    </b-field>
                </section>
                <footer class="modal-card-foot">
                    <button class="button" type="button" @click="$parent.close()">Cancel</button>
                    <button class="button is-primary" @click="$emit('submitted')">Add</button>
                </footer>
            </div>
        </form>
        `,
};

export default {
  components: {
    NewModule,
    EditModule,
  },
  data: function () {
    return {
      customers: [],
      selected: {},
      isLoading: true,
      bigLoading: false,
      isNewItemActive: false,
      isEditItemActive: false,
      formProps: {},
      newApiUrl: "https://api.jeak.co.uk",
      currencies: [],
      regions: [],
      currency_symbols: {
        USD: "$", // US Dollar
        EUR: "€", // Euro
        CRC: "₡", // Costa Rican Colón
        GBP: "£", // British Pound Sterling
        ILS: "₪", // Israeli New Sheqel
        INR: "₹", // Indian Rupee
        JPY: "¥", // Japanese Yen
        KRW: "₩", // South Korean Won
        NGN: "₦", // Nigerian Naira
        PHP: "₱", // Philippine Peso
        PLN: "zł", // Polish Zloty
        PYG: "₲", // Paraguayan Guarani
        THB: "฿", // Thai Baht
        UAH: "₴", // Ukrainian Hryvnia
        VND: "₫", // Vietnamese Dong
        CAD: "$",
        AUD: "$",
      },
    };
  },
  methods: {
    GetItems: async function () {
      const token = await this.$cognitoAuth.getIdToken();
      const config = {
        headers: { Authorization: "Bearer " + token },
      };
      const response = await axios.get(this.newApiUrl + "/customers", config);

      for (const customer of response.data) {
        if (customer.deleted) continue;
        this.customers.push(customer);
      }

      this.isLoading = false;
    },
    DeleteItem: function () {
      if (Object.entries(this.selected).length === 0) {
        this.$buefy.snackbar.open({
          message: "Please select an item to delete first!",
          type: "is-warning",
          position: "is-top",
        });
      } else {
        this.$buefy.dialog.confirm({
          title: "Deleting customer",
          message: `Are you sure you want to <b>delete</b> ${this.selected.customer_name}? No backsies!`,
          confirmText: "Delete customer",
          type: "is-danger",
          hasIcon: true,
          onConfirm: async () => {
            const token = await this.$cognitoAuth.getIdToken();
            const config = {
              headers: { Authorization: `Bearer ` + token },
            };
            axios
              .delete(this.newApiUrl + `/customers/${this.selected.disctools_id}`, config)
              .then((response) => {
                if (response.status == 200) {
                  this.$buefy.toast.open("Customer deleted!");
                  this.GetItems();
                } else {
                  this.$buefy.snackbar.open({
                    message: "An error occurred! If this persists, please contact support",
                    type: "is-danger",
                    position: "is-top",
                  });
                }
              })
              .catch((error) => {
                this.$buefy.snackbar.open({
                  message: "An error occurred! If this persists, please contact support",
                  type: "is-danger",
                  position: "is-top",
                });
                console.error(error);
              });

            this.SendNotification(`${this.$route.params.name} deleted customer ${this.selected.customer_name} from Jeak`, "warning");
          },
        });
      }
    },
    AddCustomer: async function () {
      const autocompleteBox = document.getElementById("customerAutocomplete");
      if (!this.formProps.customer) {
        autocompleteBox.setCustomValidity("A customer MUST be selected!");
        return;
      } else {
        autocompleteBox.setCustomValidity("");
      }

      this.bigLoading = true;

      const token = await this.$cognitoAuth.getIdToken();
      const config = {
        headers: { Authorization: `Bearer ` + token },
      };
      const body = {
        customer_id: this.formProps.customer.id,
        customer_name: this.formProps.customer.CustomerName,
        region_id: this.formProps.region_id,
        billing_region: this.formProps.customer.billing_region,
      };
      axios
        .post(this.newApiUrl + `/customers`, body, config)
        .then(() => {
          this.$buefy.toast.open({
            message: "Great Success",
            type: "is-success",
          });
          this.GetItems();
          this.formProps.selected = "";
          this.isNewItemActive = false;
          this.bigLoading = false;
        })
        .catch((error) => {
          this.$buefy.toast.open({
            message: "An error occurred! If this persists, please contact support",
            type: "is-danger",
          });
          console.error(error);
        });
      this.SendNotification(`${this.$route.params.name} added customer ${body.customer_name} to Jeak`, "success");
    },
    UpdateCustomer: async function () {
      const token = await this.$cognitoAuth.getIdToken();
      const config = {
        headers: { Authorization: `Bearer ` + token },
      };
      const customerId = this.selected.disctools_id;
      const body = {
        customer_name: this.selected.customer_name,
        uuid: this.selected.uuid,
        call_cost: this.selected.call_cost,
        currency: this.selected.currency,
        fixed_loc_cost: this.selected.fixed_loc_cost,
        timezone: this.selected.timezone,
        log_level: this.selected.log_level,
      };
      axios
        .put(this.newApiUrl + `/customers/${customerId}`, body, config)
        .then(() => {
          this.$buefy.toast.open({
            message: "Great Success",
            type: "is-success",
          });
          this.GetItems();
          this.selected = "";
          this.isEditItemActive = false;
        })
        .catch((error) => {
          this.$buefy.toast.open({
            message: "An error occurred! If this persists, please contact support",
            type: "is-danger",
          });
          console.error(error);
        });
      this.SendNotification(`${this.$route.params.name} updated ${this.selected.customer_name}`, "warning");
    },
    FormatAmount: function (amount, customerCurrency) {
      let currency = "";
      currency = `${this.currency_symbols[customerCurrency]} ${amount}`;
      return currency;
    },
    GetCurrencies: async function () {
      axios.get(`https://v6.exchangerate-api.com/v6/b4c58da02d0282ef7b452820/latest/GBP`).then((response) => {
        this.currencies = response.data.conversion_rates;
        this.currencies = Object.keys(this.currencies)
          .sort()
          .reduce((result, key) => {
            result[key] = this.currencies[key];
            return result;
          }, {});
      });
    },
    GetRegionIDsName: function (id) {
      for (const region of this.regions) {
        if (region.id == id) return region.region_name;
      }
    },
    GetRegions: async function () {
      const token = await this.$cognitoAuth.getIdToken();
      const config = {
        headers: { Authorization: "Bearer " + token },
      };
      axios
        .get(this.newApiUrl + "/regions", config)
        .then((response) => {
          this.regions = response.data;
          this.isLoading = false;
        })
        .catch((error) => {
          this.$buefy.snackbar.open({
            message: "An error occurred! If this persists, please contact support",
            type: "is-danger",
            position: "is-top",
          });
          console.error(error);
        });
    },
    HasGroup: function (groups = []) {
      if (!(this.$route && this.$route.params && Array.isArray(this.$route.params.groups))) return false;
      const userGroups = this.$route.params.groups.map((group) => String(group).toLowerCase());
      for (const group of groups) {
        if (userGroups.includes(String(group).toLowerCase())) return true;
      }

      return false;
    },
    SendNotification: async function (message, type) {
      const token = await this.$cognitoAuth.getIdToken();
      const config = {
        headers: { Authorization: "Bearer " + token },
      };
      const body = {
        message: message,
        type: type,
      };
      axios.post(this.newApiUrl + "/notification", body, config);
    },
    FormatDate: function (dateString) {
      return moment(dateString).format("YYYY-MM-DD hh:mm");
    },
  },
  mounted() {
    this.GetItems();
    this.GetCurrencies();
    this.GetRegions();
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h3 {
  margin: 40px 0 0;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
.container {
  margin-top: 20px;
}
#vapp {
  display: grid;
  grid-template-rows: 1fr;
}
.header {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
}
.header h1 {
  flex: 6 0 160px;
}
.buttonsGroup {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 10px;
  flex: 1;
}
.b-table {
  height: 100%;
  max-height: calc(100vh - 210px);
}
</style>

<style>
.autocomplete .dropdown-menu {
  min-width: unset !important;
}
</style>
